import { Link } from "react-router-dom";
import { ArrowLeft, ChevronRight } from "lucide-react";

export default function PublicBreadcrumb({ backTo = "/", backLabel = "Torna al sito", currentLabel }) {
  return (
    <div className="mb-6 space-y-3">
      <Link to={backTo} className="inline-flex items-center gap-2 text-sm font-medium text-slate-500 transition-colors hover:text-slate-900">
        <ArrowLeft className="h-4 w-4" /> {backLabel}
      </Link>
      {currentLabel ? (
        <div className="flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-slate-400">
          <Link to="/" className="hover:text-slate-600">Home</Link>
          <ChevronRight className="h-3.5 w-3.5" />
          <span className="text-slate-500">{currentLabel}</span>
        </div>
      ) : null}
    </div>
  );
}
